const ObjectiveOptions = () => {
    const objectiveOptions = [
        { value: "FamilyProtection", label: "Family Protection" },
        { value: "WealthProtection", label: "Wealth Protection" },
        { value: "BusinessContinuity", label: "Business Continuity" },
        { value: "AssetPreservation", label: "Asset Preservation" },
        { value: "EstateEqualization", label: "Estate Equalization" },
        { value: "IncomeReplacement", label: "Income Replacement" },
    ]
    return objectiveOptions;
};

const ImportantOptions = () => {
    const importantOptions = [
        { value: "", label: "--Select One--", disabled: true},
        { value: "Very Important", label: "Very Important" },
        { value: "Somewhat Important", label: "Somewhat Important" },
        { value: "Not Important", label: "Not Important" },
    ]
    return importantOptions;
};

const YesNoOptions = (isUnknown = false) => {
    const yesNoOptions = [
        { value: "", label: "--Select One--", disabled: true},
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
    ]
    if (isUnknown) {
        yesNoOptions.push({ value: "Unknown", label: "Unknown" })
    }
    return yesNoOptions;
}

const DeathBenefitOptions = () => {
    const deathBenefitOptions = [
        { value: "", label: "--Select One--", disabled: true},
        { value: "Life Expectancy", label: "Life Expectancy" },
        { value: "Age 100", label: "Age 100" },
        { value: "Beyond Age 100", label: "Beyond Age 100" },
        { value: "Other", label: "Other" },
    ]
    return deathBenefitOptions;
};

const BenefitType = () => {
    const benefitType = [
        { value: "", label: "--Select One--", disabled: true},
        { value: "Individual", label: "Individual" },
        { value: "Survivorship", label: "Survivorship" },
    ]
    return benefitType;
};

const PolicyOwnerOptions = () => {
    const policyOwnerOptions = [
        { value: "", label: "--Select One--", disabled: true},
        { value: "Insured", label: "Insured" },
        { value: "Spouse", label: "Spouse" },
        { value: "Business", label: "Business" },
        { value: "Other", label: "Other" },
    ]
    return policyOwnerOptions;
};

const PremiumDurationOptions = () => {
    const premiumDurationOptions = [
        { value: "", label: "--Select One--", disabled: true},
        { value: "Single", label: "Single" },
        { value: "1 Year", label: "1 Year" },
        { value: "5 Years", label: "5 Years" },
        { value: "10 Years", label: "10 Years" },
        { value: "20 Years", label: "20 Years" },
        { value: "To Age 60", label: "To Age 60" },
        { value: "To Age 65", label: "To Age 65" },
        { value: "Lifetime", label: "Lifetime" },
        { value: "Unknown", label: "Unknown" },
    ]
    return premiumDurationOptions;
};

export { ObjectiveOptions, ImportantOptions, YesNoOptions, DeathBenefitOptions, BenefitType, PolicyOwnerOptions, PremiumDurationOptions };


// WEBPACK FOOTER //
// ./src/components/Product/PermLifeInsurance/SubComponents/SelectOptions.js